export interface IMasterLayoutGuides {
    id: string;
    guides: Array<IGuide>;
}

export interface IGuide {
    type: string;
    /**
     * 参考线方向
     */
    orient: EPpGuideOrientation;

    /**
     * 对齐线颜色
     */
    color: string;

    /**
     * 对齐线位置，沿x/y轴计算
     */
    pos: number;
}

export interface IGuideModel {
    /**
     * slide参考线
     */
    slideGuideList: Array<IGuide>;

    bindSDK(sdkData): Promise<void>
}

/**
 * 参考线方向
 */
export enum EPpGuideOrientation {
    /**
     * 水平
     */
    ppHorizontalGuide = 'horz',

    /**
     * 垂直
     */
    ppVerticalGuide = 'vert',
}
